import { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Sparkles } from 'lucide-react';
import { useAuthStore } from '../../stores/auth';
import { api } from '../../utils/api';
import { canOpenProfileRoute } from '../../lib/profileAccess';

export function TopBarCredits({tenantSlug}:{tenantSlug?:string}) {
  const {user}=useAuthStore();
  const navigate=useNavigate();
  const canManage=canOpenProfileRoute(user,'/credits');
  const Tag=canManage?'button':'span';
  const [credits,setCredits]=useState<number|null>(null);
  const [creditsLoading,setCreditsLoading]=useState(true);
  // Fetch credits once on mount + whenever tenant changes.
  // Apr 23, 2026 (Bug 7) — also listen for `aura:credits:refresh` custom events so
  // the chip updates after any AI feature deducts credits (see utils/credits-bus.ts).
  useEffect(() => {
    let active = true;
    const fetchBalance = () => {
      setCreditsLoading(true);
      api.get('/credits/balance')
        .then((res) => {
          if (!active) return;
          const bal = res?.data?.data?.balance;
          setCredits(typeof bal === 'number' ? bal : null);
        })
        .catch(() => { if (active) setCredits(null); })
        .finally(() => { if (active) setCreditsLoading(false); });
    };
    fetchBalance();
    const onRefresh = () => fetchBalance();
    window.addEventListener('aura:credits:refresh', onRefresh);
    return () => {
      active = false;
      window.removeEventListener('aura:credits:refresh', onRefresh);
    };
  }, [tenantSlug]);

  return (
        <Tag
          
          onClick={canManage ? () => navigate('/credits') : undefined}
          className="flex items-center gap-1.5 rounded-md border px-2.5 py-1 text-[12px]"
          style={{
            background: 'linear-gradient(180deg, var(--saffron-50) 0%, var(--saffron-100) 100%)',
            borderColor: 'var(--saffron-100)',
            color: 'var(--saffron-600)',
            fontWeight: 500,
          }}
          title="AI credits"
        >
          <Sparkles size={13} />
          <span className="tabular-nums">
            {creditsLoading ? '…' : credits !== null ? credits.toLocaleString('en-IN') : '—'}
          </span>
          <span style={{ opacity: 0.75, fontWeight: 400 }}>credits</span>
        </Tag>
  );
}
